export const pathname = (): string => globalThis.location?.pathname;
